<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div v-if="showTitle" class="col-md-5 d-flex pl-0 medication-question">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div :class="showTitle ? 'col-md-7' : 'col-md-12'">
          <template v-if="answer && answer.answerText">
            <div class="row" v-for="(medicine, index) in parsedAns" :key="index">
              <div class="d-flex flex-wrap" v-if="medicine.previewImagesList && medicine.previewImagesList.length > 0">
                <!-- If There is an Image -->
                <div class="mr-13 mb-13 p-0 position-relative" :class="!modelPreview ? 'medication-selector-images' : ''" v-for="(image, index) in getImagesArray(medicine)" :key="index">
                  <img @contextmenu.prevent :src="image" class="participant-response__img-response" />
                  <div class="image-capture-modal">
                    <a v-if="!modelPreview" class="btn open-image-modal rounded-0" :data-target="`#image-${answer.questionId}-${index}`" data-toggle="modal"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
                  </div>
                  <div class="modal fade" :id="`image-${answer.questionId}-${index}`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <img @contextmenu.prevent :src="!!getImageFromIndex(medicine, index) ? getImageFromIndex(medicine, index) : image" class="medication-selector-modal-image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="d-flex">
                <span class="pr-15">
                  <p>{{ medicine.medicationName }}</p>
                </span>
                <span class="pr-15">
                  <p>{{ medicine.medicationDosage }}</p>
                </span>
                <span v-if="medicine.dosageUnits" class="pr-15">
                  <p>{{ medicine.dosageUnits }}</p>
                </span>
                <span v-if="medicine.numberOfDoses" class="pr-15">
                  <p>Doses: {{ medicine.numberOfDoses }}</p>
                </span>
                <span v-if="medicine.reasons" class="pr-15">
                  <p>
                    {{ medicine.reasons == "Other reason" ? "" : medicine.reasons }}
                  </p>
                </span>
                <span v-if="medicine.otherReasons" class="pr-0">
                  <p>{{ medicine.otherReasons }}</p>
                </span>
              </div>
            </div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0 medication-question">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <template v-if="answer && answer.answerText">
            <div class="row mb-5" v-for="(medicine, index) in updatedAns" :key="index">
              <!-- If Medicine is Selected from the List -->
              <template v-if="medicine.listImages.length < 1">
                <div class="col-md-6 p-0">
                  <b-form-select v-model="medicine.medicationName" size="sm" :disabled="answer && answer.isDisabled" @change="clearDosage(medicine)" name="MedicationNames" class="fs-12 field-h40">
                    <option v-for="(med, index) in removeNonIdMeds(medicines)" :key="index" :value="med.name.trim()">
                      {{ med.name }}
                    </option>
                  </b-form-select>
                </div>
                <div class="col-md-6 p-0">
                  <b-form-select
                    v-model="medicine.medicationDosage"
                    size="sm"
                    name="medicationDosage"
                    :disabled="answer && answer.isDisabled"
                    @change="answerUpdated"
                    class="fs-12 field-h40"
                    :class="{
                      'is-danger': hasFieldError && errorIndex.indexOf(index) >= 0
                    }"
                  >
                    <option v-for="(dos, index) in medicineForDosage(medicine)" :key="index" :value="dos">
                      {{ dos }}
                    </option>
                  </b-form-select>
                  <span v-if="hasFieldError && errorIndex.indexOf(index) >= 0" class="text-danger">
                    <p>{{ fieldErrorText }}</p>
                  </span>
                  <span v-else-if="hasFieldWarning" class="text-danger">{{ fieldWarningText }}</span>
                </div>
                <div class="col-md-6 p-0">
                  <b-form-select
                    v-model="medicine.dosageUnits"
                    size="sm"
                    name="medicationDosage"
                    :disabled="answer && answer.isDisabled"
                    @change="answerUpdated"
                    class="fs-12 field-h40"
                    :class="{
                      'is-danger': hasFieldError && errorIndex.indexOf(index) >= 0
                    }"
                  >
                    <option value="" disabled selected>Select dosage unit</option>
                    <option v-for="(unit, index) in question.dosageUnits" :key="index" :value="unit">
                      {{ unit }}
                    </option>
                  </b-form-select>
                  <span v-if="hasFieldError && errorIndex.indexOf(index) >= 0" class="text-danger">
                    <p>{{ fieldErrorText }}</p>
                  </span>
                  <span v-else-if="hasFieldWarning" class="text-danger">{{ fieldWarningText }}</span>
                </div>
                <div class="col-md-6 p-0">
                  <input v-model="medicine.numberOfDoses" class="form-control mb-15" type="number" placeholder="Number Of Doses" @change="answerUpdated" />
                </div>
                <div class="col-md-6 p-0">
                  <b-form-select
                    v-model="medicine.reasons"
                    size="sm"
                    name="medicationDosage"
                    :disabled="answer && answer.isDisabled"
                    @change="clearInput(medicine.reasons, index)"
                    class="fs-12 field-h40"
                    :class="{
                      'is-danger': hasFieldError && errorIndex.indexOf(index) >= 0
                    }"
                  >
                    <option value="" disabled selected>Select reason of use</option>
                    <option v-for="(reason, index) in question.reasons" :key="index" :value="reason">
                      {{ reason }}
                    </option>
                    <option value="Other reason" v-if="question.addOtherReason">Other reason</option>
                  </b-form-select>
                  <span v-if="hasFieldError && errorIndex.indexOf(index) >= 0" class="text-danger">
                    <p>{{ fieldErrorText }}</p>
                  </span>
                  <span v-else-if="hasFieldWarning" class="text-danger">{{ fieldWarningText }}</span>
                  <input v-if="medicine.reasons == 'Other reason'" v-model="medicine.otherReasons" class="form-control mb-15" type="text" placeholder="Enter other reason" @change="answerUpdated" />
                </div>
              </template>
              <div class="images-selected" v-else>
                <div class="d-flex flex-wrap" v-if="medicine.previewImagesList && medicine.previewImagesList.length > 0">
                  <div class="position-relative mr-13 mb-13 p-0 medication-selector-images" v-for="(image, index) in getImagesArray(medicine)" :key="index">
                    <img @contextmenu.prevent :src="image" class="participant-response__img-response" />
                    <div class="image-capture-modal">
                      <a class="btn open-image-modal rounded-0" :data-target="`#image-${answer.questionId}-edit-${index}`" data-toggle="modal"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
                    </div>
                    <div class="modal fade" :id="`image-${answer.questionId}-edit-${index}`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <img @contextmenu.prevent :src="!!getImageFromIndex(medicine, index) ? getImageFromIndex(medicine, index) : image" class="medication-selector-modal-image" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE  -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0 medication-question">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 pl-30">
                <div class="row" v-for="(medicine, index) in parsedAns" :key="index">
                  <div class="d-flex flex-wrap" v-if="medicine.previewImagesList && medicine.previewImagesList.length > 0">
                    <!-- If There is an Image -->
                    <div class="position-relative mr-13 mb-13 p-0 medication-selector-images" v-for="(image, index) in getImagesArray(medicine)" :key="index">
                      <img @contextmenu.prevent :src="image" class="participant-response__img-response" />
                      <div class="image-capture-modal">
                        <a class="btn open-image-modal rounded-0" :data-target="`#image-${answer.question_id}-${index}-history`" data-toggle="modal"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
                      </div>
                      <div class="modal fade" :id="`image-${answer.question_id}-${index}-history`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <img @contextmenu.prevent :src="!!getImageFromIndex(medicine, index) ? getImageFromIndex(medicine, index) : image" class="medication-selector-modal-image" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="d-flex">
                    <span class="pr-15">
                      <p>{{ medicine.medicationName }}</p>
                    </span>
                    <span class="pr-15">
                      <p>{{ medicine.medicationDosage }}</p>
                    </span>
                    <span v-if="medicine.dosageUnits" class="pr-15">
                      <p>{{ medicine.dosageUnits }}</p>
                    </span>
                    <span v-if="medicine.numberOfDoses" class="pr-15">
                      <p>Doses: {{ medicine.numberOfDoses }}</p>
                    </span>
                    <span v-if="medicine.reasons" class="pr-15">
                      <p>
                        {{ medicine.reasons == "Other reason" ? "" : medicine.reasons }}
                      </p>
                    </span>
                    <span v-if="medicine.otherReasons" class="pr-0">
                      <p>{{ medicine.otherReasons }}</p>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 d-flex pl-0">
                <div class="row">
                  <div class="d-inline-block ml-25 pt-10" v-if="showScore && answer.score != null">
                    <label>Score</label>
                    <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                      {{ answer.score }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div v-if="answer.edit_status == 1">
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>
            <template v-if="answer && answer.privius_answer_text">
              <div class="col-md-7">
                <div class="row" v-for="(medicine, index) in previousAns" :key="index">
                  <div class="d-flex" v-if="medicine.previewImagesList && medicine.previewImagesList.length > 0">
                    <!-- If There is an Image -->
                    <div class="col-md-4 mx-1 p-0" v-for="(image, index) in getImagesArray(medicine)" :key="index">
                      <img @contextmenu.prevent :src="image" class="participant-response__img-response" />
                      <div class="image-capture-modal">
                        <a class="btn open-image-modal rounded-0" :data-target="`#image-${answer.question_id}-${index}-history`" data-toggle="modal"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
                      </div>
                      <div class="modal fade" :id="`image-${answer.question_id}-${index}-history`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <img @contextmenu.prevent :src="!!getImageFromIndex(medicine, index) ? getImageFromIndex(medicine, index) : image" class="medication-selector-modal-image" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="d-flex">
                    <span class="pr-15">
                      <p>{{ medicine.medicationName }}</p>
                    </span>
                    <span class="pr-15">
                      <p>{{ medicine.medicationDosage }}</p>
                    </span>
                    <span v-if="medicine.dosageUnits" class="pr-15">
                      <p>{{ medicine.dosageUnits }}</p>
                    </span>
                    <span v-if="medicine.numberOfDoses" class="pr-15">
                      <p>Doses: {{ medicine.numberOfDoses }}</p>
                    </span>
                    <span v-if="medicine.reasons" class="pr-15">
                      <p>
                        {{ medicine.reasons == "Other reason" ? "" : medicine.reasons }}
                      </p>
                    </span>
                    <span v-if="medicine.otherReasons" class="pr-0">
                      <p>{{ medicine.otherReasons }}</p>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 d-flex pl-0">
                <div class="row">
                  <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                    <label>Score</label>
                    <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                      {{ answer.privius_score }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";

export default {
  name: "MedicationSelectorResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: {},
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      errorIndex: []
    };
  },
  props: {
    answer: Object,
    question: Object,
    mode: Number,
    surveyData: Object,
    usage: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    showTitle: {
      type: Boolean,
      default: true
    },
    modelPreview: {
      type: Boolean,
      default: false
    },
    activityType: String
  },
  mounted() {
    this.addCustomConfig();
    this.updatedAns = this.parsedAns && this.parsedAns.map(o => ({ ...o }));
  },
  watch: {
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    },
    updatedAns: {
      handler() {
        this.checkForFieldErrors();
      },
      deep: true
    }
  },
  methods: {
    medicineForDosage({ medicationName, isOtherSelected, medicationDosage }) {
      try {
        const dosageIndex = this.medicines.findIndex(m => m.name.trim() == medicationName.trim());
        const dosage = this.medicines[dosageIndex].dosage;
        if (isOtherSelected && !!medicationDosage && dosage.indexOf(medicationDosage) < 0) {
          dosage.push(medicationDosage);
        }
        const filteredDosage = dosage.filter(item => item);
        return filteredDosage;
      } catch (err) {}
    },
    addCustomConfig() {
      if (this.mode == 0 || this.mode == 1) {
        if (this.parsedAns) {
          this.parsedAns.map(med => {
            //Scenario Where All new Medicine has been Added
            if (!med.isOtherSelected && !med.isSelected && med.listImages.length < 1) {
              const customMed = {
                category: "Brand",
                name: `${med.medicationName}`,
                dosage: [`${med.medicationDosage}`]
              };
              this.medicines.unshift(customMed);
            }
            //Scenario Where only Custom Dosage has been Added
            else if (med.isSelected && med.isOtherSelected) {
              const findMed = this.medicines.findIndex(m => m.name == med.medicationName);
              if (findMed && this.medicines[findMed] && this.medicines[findMed].dosage) {
                this.medicines[findMed].dosage.unshift(med.medicationDosage);
              }
            }
          });
        }
      }
    },
    clearDosage(item) {
      if (this.answer) {
        this.answer.score = this.question.score;
        this.answer.computedScore = this.answer.score;
        item.medicationDosage = "";
        this.answerUpdated();
      }
    },
    clearInput(reasons, index) {
      if (event.target.value != "Other reason") {
        this.updatedAns[index].otherReasons = "";
      }
      this.answerUpdated();
    },
    answerUpdated() {
      this.$nextTick(() => {
        this.$emit("answerChanged", {
          questionId: this.question.id,
          newAns: JSON.stringify(this.updatedAns)
        });
      });
    },
    checkForFieldErrors() {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.question.isSkippable = true;
              this.errorIndex.length = 0;
              if (this.updatedAns) {
                this.updatedAns.forEach((elem, index) => {
                  if (elem.listImages.length === 0 && (elem.medicationDosage === "" || typeof elem.medicationDosage === "undefined")) {
                    this.errorIndex.push(index);
                    this.hasFieldWarning = true;
                    softDataCheck = true;
                    this.fieldWarningText = "This field is required.";
                  }
                });
              }
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.question.isSkippable = false;
              this.errorIndex.length = 0;
              if (this.updatedAns) {
                this.updatedAns.forEach((elem, index) => {
                  if (elem.listImages.length === 0 && (elem.medicationDosage === "" || typeof elem.medicationDosage === "undefined")) {
                    this.errorIndex.push(index);
                    this.hasFieldError = true;
                    this.fieldErrorText = "This field is required.";
                  }
                });
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
    },
    removeNonIdMeds(data) {
      return data.filter(el => {
        if (el.id) {
          return el;
        }
      });
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    },
    getImagesArray(medicine) {
      if (medicine.thumbnailList && medicine.thumbnailList.length > 0 && !!medicine.thumbnailList[0]) {
        return medicine.thumbnailList;
      } else {
        return medicine.previewImagesList;
      }
    },
    getImageFromIndex(medicine, index) {
      return medicine.previewImagesList[index];
    }
  },
  computed: {
    medicines() {
      return this.question ? this.question.content[0].options : [];
    },
    parsedAns() {
      if (this.answer) {
        return JSON.parse(this.answer[this.usage.ANSWER_TEXT]);
      }
      return [];
    },
    previousAns() {
      if (this.answer && this.answer.privius_answer_text) {
        return JSON.parse(this.answer.privius_answer_text);
      }
      return [];
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.participant-response__img-response {
  max-width: 90px;
  max-height: 100px;
  width: auto;
  height: auto;
}

.image-capture-modal {
  left: 90px;
  position: absolute;
}
.image-capture-modal .open-image-modal {
  margin-left: 45px;
  background-color: #d7dfeb;
}

.image-capture-modal-content .modal-content {
  background-color: transparent !important;
  border: none !important;
}

.image-capture-modal-content .modal-header {
  border: none !important;
  padding: 0 !important;
}
.image-capture-modal-content .close {
  background-color: transparent !important;
  border: 0 !important;
  color: #fff !important;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-weight: normal !important;
  text-shadow: inherit;
  opacity: 1;
}

.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
.medication-question {
  overflow-wrap: break-word;
  overflow: auto;
}

.medication-selector-modal-image {
  max-width: 400px;
  max-height: 704px;
  width: auto;
  height: auto;
}

.medication-selector-images {
  width: 110px;
  height: 100px;
  background: #0d0c0c;
  text-align: center;
}
</style>
